export const DOCUMENT_TYPE_CLIENT = 'client';
